import React, {useState} from "react";
import {connect, useSelector} from "react-redux";
import {Button, Card, CardBody, CardTitle, Row, Col} from "reactstrap";



// components

import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {LIST} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";

// services
import {queryExecutorService} from "../../../jwt/_services/security/queryExecutorService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {CSVLink} from "react-csv";




const QueryExecutorList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));

    const [searching, setSearching] = useState(false);
    const [result, setResult] = useState(null);
    const [query, setQuery] = useState(null);



    const executeQuery = () => {
        setSearching(true)

        const requestData ={
            item: {
                query
            }
        }



        queryExecutorService.search(0, 100, requestData)
            .then( result => {
                console.log({result})
                setResult(result)
            })
            .catch( e => console.error(e))
            .finally( () => setSearching(false) )
    }


    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                {
                    result !== null && <CSVLink
                        data={result}
                        filename={`result.csv`}
                    >
                        <Button
                            outline color="primary"
                            size="sm"
                            className="btn-cancel ml-2"
                        >
                            <i className="fa fa-download"/>CSV
                        </Button>
                    </CSVLink>
                }
            </div>
        </CardTitle>

        <CardBody>
            <Row>
                <Col>
                    <textarea
                        className="form-control"
                        style={{width: '100%', height: '20rem'}}
                        placeholder="Escribe aquí..."
                        value={query || ''}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <div className="float-right">
                        <GenericButton
                            disabled={searching || !query}
                            loading={searching}
                            style={'table'}
                            label={'Ejecutar'}
                            toolTip={'Agregar'}
                            icon={'a fa-upload'}
                            permission={'add'}
                            onClick={executeQuery}
                        />
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(QueryExecutorList);